export default "__VITE_ASSET__DDwX7fib__"